module.exports = "/_next/static/images/chi-2x-449219e37102578fbe3a006e5ad88ca5.jpg.webp";